<form [formGroup]="searchForm">
  <div>
    <mat-form-field>
      <mat-label>{{ title || "input-part" | translate }}</mat-label>
      <input
        type="text"
        matInput
        [matAutocomplete]="autoComplete"
        formControlName="description"
      />
      <mat-autocomplete autoActiveFirstOption #autoComplete="matAutocomplete">
        <mat-option disabled class="loading" *ngIf="loading">
          <mat-spinner diameter="25"></mat-spinner>
        </mat-option>
        <mat-option
          *ngFor="let part of parts"
          (onSelectionChange)="handlePartChange($event, part)"
          [value]="part.description"
          class="autocomplete"
        >
          {{ part.description }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        translate
        *ngIf="
          this.searchForm.controls.description.touched && !this.searchForm.valid
        "
        >{{ "required-part" | translate }}</mat-error
      >
    </mat-form-field>
  </div>
</form>
